import type { ReactNode } from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';

export const ResizeObservers = (props: {
  children: (rect: DOMRect) => ReactNode;
}) => {
  const { children } = props;
  const [rect, setRect] = useState<DOMRect>();
  const ref = useRef<HTMLDivElement>(null);

  const handleResizeWindow = () => {
    if (ref.current) {
      setRect(ref.current.getBoundingClientRect());
    }
  };

  useEffect(() => {
    if (ref.current) {
      window.addEventListener('resize', handleResizeWindow);
    }
    return () => {
      window.removeEventListener('resize', handleResizeWindow);
    };
  }, []);

  return (
    <div
      data-id="resize-observer"
      style={{ height: '100%' }}
      ref={useCallback(
        (instance: HTMLDivElement | null) => {
          if (instance && !rect) {
            setRect(instance.getBoundingClientRect());
          }
          if (instance) {
            Reflect.set(ref, 'current', instance);
          }
        },
        [rect],
      )}
    >
      {rect ? children(rect) : null}
    </div>
  );
};
